import styles from './styles.module.scss';

function Curve({ fill, windowSize }) {
    // 👇️ paste SVG into a component
    // take fill and stroke colors as props
    return (
        windowSize <= 768 ? <svg xmlns="http://www.w3.org/2000/svg" width="428" height="658" viewBox="0 0 428 658" fill="none" className={styles.curve}>
            <path d="M0 8.84675C0 8.84675 78.5 48.8699 132 48.8699C185.5 48.8699 219.269 34.3486 280 15.0609C372.5 -14.3162 428 8.33639 428 8.33639V658H0V8.84675Z" fill={fill}/>
        </svg>
        :
        <svg xmlns="http://www.w3.org/2000/svg" width="1512" height="890" viewBox="0 0 1512 890" fill="none" className={styles.curve}>
            <path d="M0 0C0 0 208.734 94.3603 363 128.454C689.768 200.67 888.148 51.1452 1224 76.0236C1337.12 84.4028 1512 110.54 1512 110.54V890H0V0Z" fill={fill}/>
        </svg>
    );
}

export default Curve